<script setup lang="ts">
import { Icon } from '@/shared/ui';

const { state, size } = defineProps<{ state: boolean; size: string | number }>();
</script>

<template>
  <Icon
    :name="state ? 'lucide:check-check' : 'lucide:check'"
    :width="size"
    :height="size"
  />
</template>
